import * as React from 'react';

import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { VoiceboxReasoningStep } from 'bones/components/molecules/Voicebox/hooks/useReasoningStepsFromMessage';
import { VoiceboxReasoningSteps } from 'bones/components/molecules/Voicebox/shared/VoiceboxReasoningSteps';
import { VoiceboxResponseMessage } from 'bones/constants/voicebox/message';
import { VoiceboxSettings } from 'bones/constants/voicebox/settings';
import { Accordion } from 'bones/design-system/components/Accordion';

export interface VoiceboxChatReasoningProps {
  isOpen: boolean;
  message: VoiceboxResponseMessage;
  reasoningSteps: VoiceboxReasoningStep[];
  setIsOpen: (isOpen: boolean) => void;
  settings: VoiceboxSettings;
}

export const VoiceboxChatReasoning: React.VFC<VoiceboxChatReasoningProps> = ({
  isOpen,
  message,
  reasoningSteps,
  setIsOpen,
  settings,
}) => {
  const { copy, testIds } = useVoiceboxSchema();

  const status = message.pending
    ? reasoningSteps[reasoningSteps.length - 1]?.summary ||
      copy.message.reasoning.pending
    : copy.message.reasoning.finished;

  return (
    <Accordion
      className="vb-voicebox-chat-reasoning"
      icon="left"
      isOpen={isOpen}
      label={status}
      onInteraction={(nextIsOpen: boolean) => setIsOpen(nextIsOpen)}
      size="md"
      testId={testIds.messages.reasoning}
    >
      <VoiceboxReasoningSteps
        message={message}
        reasoningSteps={reasoningSteps}
        settings={settings}
      />
    </Accordion>
  );
};
